import {
  ChangePassword,
  CreatePasswordCard,
  EmailCheck,
  EmailSent,
  Login,
  PasswordUpdatedMessage,
  ResetPassword,
  SignUp,
  SuccessCard,
  ThanksCard,
  VerifyCard,
} from "@modules/index";

import { Dashboard } from "~/Modules/Dashboard/Dashboard";
import { FAQ } from "~/Modules/FAQ/FAQ";
import { FinancingProducts } from "~/Modules/FinancingProducts/FinancingProducts";
import { Gallery } from "~/Modules/Gallery/Gallery";
import { InfratechMarketPlaceDetailView } from "~/Modules/InfratechMarketPlace/InfratechMarketplaceDetailView";
import { InfratechMarketPlaceList } from "./../Modules/InfratechMarketPlace/InfratechMarketplaceList";
import { InfratechMarketplace } from "./../Modules/InfratechMarketPlace/InfratechMarketplace";
import { InvestmentDetailView } from "~/Modules/InvestmentHub/InvestmentHubDetailView";
import { InvestmentHub } from "~/Modules/InvestmentHub/InvestmentHub";
import { KnowledgeHub } from "~/Modules/KnowledgeHub/KnowledgeHub";
import { KnowledgeHubTemp } from "~/Modules/KnowledgeHubTemp/KnowledgeHubTemp";
import { LandingPage } from "~/Modules/LandingPage/LandingPage";
import { NewProject } from "~/Modules/InvestmentHub/NewProject/NewProject";
import { PageComingSoon } from "~/Components";
import { PooledFinancing } from "~/Modules/PooledFinancing/PooledFinancing";
import { ReactNode } from "react";
import { Redirect } from "@modules/Auth/Redirect";
import { StandardDocumentation } from "~/Modules/StandardDocumentation/StandardDocumentation";
import { UnAuthorized } from "@components/ErrorHandlers/UnAuthorized";
import { permissions } from "@utils/Roles";

interface RouteBase {
  path: string;
  element: ReactNode;
}

interface ProtectedRoutes extends RouteBase {
  roles: string[];
}

export const protectRoutes: ProtectedRoutes[] = [
  {
    path: "/dashboard",
    element: <LandingPage />,
    roles: ["*"],
  },
  {
    path: "/faq",
    element: <FAQ />,
    roles: ["*"],
  },
  // {
  //   path: "/landing-page",
  //   element: <LandingPage />,
  //   roles: ["*"],
  // },
  // {
  //   path: "/esg-hub",
  //   element: <LandingPage />,
  //   roles: ["*"],
  // },
  // {
  //   path: "/investment-asean",
  //   element: <LandingPage />,
  //   roles: ["*"],
  // },
  {
    path: "/infratech-marketplace",
    element: <InfratechMarketplace />,
    roles: ["*"],
  },
  {
    path: "/infratech-marketplace/list",
    element: <InfratechMarketPlaceList />,
    roles: ["*"],
  },
  {
    path: "/infratech-marketplace/view/:id",
    element: <InfratechMarketPlaceDetailView />,
    roles: ["*"],
  },
  {
    path: "/knowledge-hub",
    element: <KnowledgeHub />,
    roles: ["*"],
  },
  {
    path: "/knowledgehub",
    element: <KnowledgeHubTemp />,
    roles: ["*"],
  },
  {
    path: "/investment-hub/new-project",
    element: <NewProject />,
    roles: ["*"],
  },
  {
    path: "/investment-hub",
    element: <InvestmentHub />,
    roles: ["*"],
  },
  {
    path: `/investment-hub/view/:id`,
    element: <InvestmentDetailView />,
    roles: ["*"],
  },
  {
    path: "/gallery",
    element: <Gallery />,
    roles: ["*"],
  },
  {
    path: "/pooled-financing",
    element: <PooledFinancing />,
    roles: ["*"],
  },
  {
    path: "/financing-products",
    element: <FinancingProducts />,
    roles: ["*"],
  },
  {
    path: "/standard-documentation",
    element: <StandardDocumentation />,
    roles: ["*"],
  },
  {
    path: "/page/coming-soon",
    element: <PageComingSoon />,
    roles: ["*"],
  },
];

export const globalRoutes = [
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/signup",
    element: <SignUp />,
  },
  // {
  //   path: "/auth/thanks",
  //   element: <ThanksCard />,
  // },
  // {
  //   path: "/auth/verify",
  //   element: <VerifyCard />,
  // },
  // {
  //   path: "/auth/create-password",
  //   element: <CreatePasswordCard />,
  // },
  // {
  //   path: "/auth/signup/success",
  //   element: <SuccessCard />,
  // },
  {
    path: "/auth/verify-email",
    element: <EmailCheck />,
  },
  // {
  //   path: "/auth/verify-email/sent",
  //   element: <EmailSent />,
  // },
  // {
  //   path: "/auth/reset-password",
  //   element: <ResetPassword />,
  // },
  // {
  //   path: "/auth/password-updated-message",
  //   element: <PasswordUpdatedMessage />,
  // },
  // {
  //   path: "/auth/change-password",
  //   element: <ChangePassword />,
  //   roles: ["*"],
  // },
  // {
  //   path: "/authorize/redirect",
  //   element: <Redirect />,
  // },
  // {
  //   path: "/unauthorized-entry",
  //   element: <UnAuthorized />,
  // },
];
